// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13LRZ","largestCol":"styles_largestCol__3Co9W","smallestCol":"styles_smallestCol__TH2J7"};